var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleLock = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 23.293c6.629 0 12-5.055 12-11.293C24 5.762 18.629.707 12 .707S0 5.762 0 12c0 6.238 5.371 11.293 12 11.293zm3-13.93h.602c.66 0 1.199.535 1.199 1.184v5.918c0 .648-.54 1.183-1.2 1.183H8.403A1.2 1.2 0 017.2 16.465v-5.918a1.2 1.2 0 011.203-1.184H9V8.18c0-1.633 1.344-2.957 3-2.957s3 1.324 3 2.957zM10.14 8.18v1.183h3.72V8.18c0-1.012-.833-1.832-1.86-1.832-1.023 0-1.86.82-1.86 1.832zm0 0"
  })));
};
export default SvgCircleLock;